module.exports = __webpack_public_path__ + "static/img/7.2751dc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/7.jpg
// module id = ECfN
// module chunks = 0